import type { DeviceV2, PatientV2 } from "../types";
import type { PatientReadingTab } from "../devices/deviceTabConfig";
import { PatientDevicesReadings } from "../devices/PatientDevicesReadings";

export type DeviceTabExportControls = {
  visible: boolean;
  loading: boolean;
  onExport: () => void;
};

export function DevicesTab({
  patient,
  devices,
  devicesTimezone,
  visibleTabs,
  devicesLoading = false,
  devicesReady = false,
  isPractitioner = false,
  activeSubTab,
  onActiveSubTabChange,
  onExportControlsChange,
  onRefreshDevices,
  onRefreshReadingCount,
}: {
  patient: PatientV2 | null;
  devices: DeviceV2[];
  devicesTimezone?: string;
  visibleTabs: PatientReadingTab[];
  devicesLoading?: boolean;
  devicesReady?: boolean;
  isPractitioner?: boolean;
  activeSubTab?: string;
  onActiveSubTabChange?: (tab: string) => void;
  onExportControlsChange?: (controls: DeviceTabExportControls | null) => void;
  onRefreshDevices?: () => Promise<void>;
  onRefreshReadingCount?: () => void;
}) {
  return (
    <PatientDevicesReadings
      patient={patient}
      devices={devices}
      devicesTimezone={devicesTimezone}
      visibleTabs={visibleTabs}
      devicesLoading={devicesLoading}
      devicesReady={devicesReady}
      isPractitioner={isPractitioner}
      showOnlyAssignedDeviceTabs={patient?.typeOfPatient === "outpatient"}
      activeTab={activeSubTab}
      onActiveTabChange={onActiveSubTabChange}
      hideTabList
      hideHeaderExport
      onExportControlsChange={onExportControlsChange}
      onRefreshDevices={onRefreshDevices}
      onRefreshReadingCount={onRefreshReadingCount}
    />
  );
}
